const GOLDS = ["#F3E5AB", "#D4AF37", "#AA7C11", "#E5C158", "#8A6A1F"];

function hashName(name) {
  let h = 2166136261;
  for (let i = 0; i < name.length; i++) {
    h ^= name.charCodeAt(i);
    h = Math.imul(h, 16777619) >>> 0;
  }
  return h;
}

function pick(rand, arr) {
  return arr[rand() % arr.length];
}

export default function UserAvatar({ name = "?", size = 80, className = "" }) {
  const h = hashName(name);
  let seed = h;
  const rand = () => {
    seed = (Math.imul(seed, 1103515245) + 12345) >>> 0;
    return seed % 100000;
  };
  const gid = `ag${h.toString(36)}`;
  const main = pick(rand, GOLDS);
  const accent = pick(rand, GOLDS);
  const dim = pick(rand, GOLDS);
  const cells = [];
  for (let y = 0; y < 5; y++) {
    for (let x = 0; x < 3; x++) {
      if (rand() % 100 < 52) {
        cells.push([x, y]);
        if (x !== 2) cells.push([4 - x, y]);
      }
    }
  }
  const initial = (name || "?").slice(-1).toUpperCase();
  return (
    <svg
      viewBox="0 0 100 100"
      width={size}
      height={size}
      className={className}
      data-testid="user-avatar"
      role="img"
      aria-label="会员头像"
    >
      <defs>
        <linearGradient id={gid} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor={main} />
          <stop offset="100%" stopColor={accent} />
        </linearGradient>
        <radialGradient id={`${gid}g`} cx="0.5" cy="0.35" r="0.9">
          <stop offset="0%" stopColor="#17171F" />
          <stop offset="100%" stopColor="#0A0A0E" />
        </radialGradient>
      </defs>
      <rect width="100" height="100" fill={`url(#${gid}g)`} />
      {cells.map(([x, y], i) => (
        <path
          key={i}
          d={`M ${14 + x * 16} ${8 + y * 16} l 6 6 l -6 6 l -6 -6 Z`}
          fill={i % 3 === 0 ? `url(#${gid})` : i % 3 === 1 ? dim : "none"}
          stroke={i % 3 === 2 ? dim : "none"}
          strokeWidth={i % 3 === 2 ? 1.2 : 0}
          opacity={i % 3 === 2 ? 0.85 : 0.92}
        />
      ))}
      <rect x="3" y="3" width="94" height="94" fill="none" stroke={`url(#${gid})`} strokeWidth="2" opacity="0.7" />
      <rect x="7" y="7" width="86" height="86" fill="none" stroke={dim} strokeWidth="0.8" opacity="0.3" />
      <circle cx="50" cy="50" r="21" fill="rgba(7,7,9,0.6)" />
      <text
        x="50"
        y="50"
        textAnchor="middle"
        dominantBaseline="central"
        fontSize="34"
        fontWeight="900"
        fontFamily="'Noto Serif SC', serif"
        fill="#070709"
        stroke={main}
        strokeWidth="1"
        paintOrder="stroke"
        style={{ textShadow: "0 2px 8px rgba(0,0,0,0.6)" }}
      >
        {initial}
      </text>
    </svg>
  );
}
